<template>
  <v-dialog :value="true" width="900" persistent>
    <v-card>
      <v-card-title>
        <span class="table-card-title">Grupos de precificação</span>
        <p class="texto-corrido email-subtitle mt-2 mb-0">{{ description }}.</p>
      </v-card-title>
      <div class="px-6 pt-4">
        <mf-text-input v-model="name" :hide-details="!errorName" dense :errors-messages="errorName" label="Nome" outlined class="mb-4" />
        <mf-select-units
          title="Lojas no grupo de precificação"
          is-section
          hide-ecommerce-configuration
          :selected-units.sync="selectedUnits"
          :unavailable-units="unavailableUnitsIds"
          :units="units"
          :tag-list="tagList"
          :group-id="groupId"
          is-price-group
        />
      </div>
      <mf-action-buttons
        class="px-6 py-2"
        :primary-button="{
          text: 'Confirmar',
          action: upsertGroup,
          isVisible: true,
          isLoading: loading,
          isDisabled: !selectedUnits.length,
        }"
        :extra-button="{
          text: 'Cancelar',
          action: closeModal,
          isVisible: true,
          isLoading: loading,
        }"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import { UPSERT_UNIT_GROUPS } from '@/modules/configuracoes/lojas/graphql'
export default {
  name: 'EditGroupDialog',
  props: {
    selectedGroupToEdit: {
      type: Object,
      default: () => {},
    },
  },

  data: () => ({
    loading: false,
    name: '',
    errorName: '',
    selectedUnits: [],
  }),

  computed: {
    description() {
      return `Dê um nome para esse Grupo de precificação e selecione as lojas participantes logo abaixo. Para salvar esse ${
        this.groupId ? '' : 'novo'
      } grupo, clique em “Confirmar”`
    },
    unavailableUnitsIds() {
      return []
    },
    tagList() {
      return this.$store.getters.tagList
    },
    units() {
      return this.$store.getters.units
    },
    groupId() {
      return this.selectedGroupToEdit && this.selectedGroupToEdit._id
    },
  },

  created() {
    if (this.selectedGroupToEdit && this.selectedGroupToEdit._id) {
      this.name = this.selectedGroupToEdit.name
      this.selectedUnits = this.selectedGroupToEdit.units
    }
  },

  methods: {
    async upsertGroup() {
      if (!this.name) {
        this.errorName = 'Esse campo deve ser preenchido'
        return
      }
      this.loading = true
      const data = {
        name: this.name,
        units: this.selectedUnits,
      }
      if (this.groupId) data._id = this.groupId
      await this.$apollo
        .mutate({
          mutation: UPSERT_UNIT_GROUPS,
          variables: { data },
          fetchPolicy: 'no-cache',
        })
        .then(() => {
          this.$snackbar({ message: 'Grupo de precificação criado com sucesso', snackbarColor: 'success' })
          this.loading = false
          this.$emit('update-table')
          this.closeModal()
        })
        .catch((err) => {
          console.log(err)
          this.$snackbar({ message: 'Erro ao salvar grupo de precificação', snackbarColor: 'error' })
          this.loading = false
        })
    },
    closeModal() {
      this.errorName = ''
      this.$emit('close')
    },
  },
}
</script>

<style scoped lang="scss">
.blue-action-text {
  color: $marca-0-l40;
  text-decoration: underline;
  text-align: right;
  &:hover {
    cursor: pointer;
  }
  font-size: 14px;
}

.email-subtitle {
  word-break: normal;
  font-size: 16px;
}

::v-deep .section-title {
  font-size: 18px !important;
}
::v-deep .v-data-table__wrapper {
  min-height: 272px;
  max-height: 272px;
}

::v-deep .select-units {
  padding: 0 !important;
}
</style>
